import { DistributorNavBar } from '@/components/blocks/DistributorNavBar';
import { HeaderNavBarContentRecommendation } from '@/components/content/Header/parts/HeaderNavBarContentRecommendation';
import { HeaderNavBarMobile } from '@/components/content/Header/parts/HeaderNavBarMobile';
import { HeaderNavBar } from '@/components/content/Header/parts/NavBar';
import { Promotions } from '@/components/content/Header/parts/Promotions';
import { headerContainerSX } from '@/components/content/Header/styles/container';
import { ID } from '@/data/types/Basic';
import { Box } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { FC, Fragment, useEffect, useMemo, useRef, useState } from 'react';

export const useMobileHeaderQuery = () => useMediaQuery('(max-width:968px)');

export const Header: FC<{
	id: ID;
}> = ({ id }) => {
	const isMobile = useMobileHeaderQuery();
	const [visible, setVisible] = useState(true);
	const lastScrollYRef = useRef(0);

	const navBarRecommendation = useMemo(() => <HeaderNavBarContentRecommendation />, []);

	const handleScroll = () => {
		const currentScrollY = window.scrollY;

		if (currentScrollY > lastScrollYRef.current && currentScrollY > 100) {
			setVisible(false);
		} else {
			setVisible(true);
		}

		lastScrollYRef.current = currentScrollY;
	};

	useEffect(() => {
		window.addEventListener('scroll', handleScroll);
		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []);

	return (
		<Fragment>
			<DistributorNavBar />
			<Box sx={{ position: 'relative', zIndex: 9001 }}>
				<Promotions id={id} mobile={isMobile} />
			</Box>
			<Box component="header" sx={headerContainerSX(visible)}>
				{isMobile ? (
					<HeaderNavBarMobile id={id} navBarRecommendation={navBarRecommendation} />
				) : (
					<HeaderNavBar navBarRecommendation={navBarRecommendation} />
				)}
			</Box>
		</Fragment>
	);
};
